import { TIMER_TIMESTAMPS } from './constants';

/** Restarts the performance timeline used to compute displayed game time. */
export const restartGameTimerMarks = (): void => {
  globalThis?.performance?.clearMeasures?.(TIMER_TIMESTAMPS.GAME_MEASURE);
  globalThis?.performance?.clearMarks?.(TIMER_TIMESTAMPS.GAME_MARK);
  globalThis?.performance?.mark?.(TIMER_TIMESTAMPS.GAME_MARK);
};
